import { produce } from 'immer';

import { AUDIO_RECORDINGS_ACTION_TYPE } from '../actions';

const initialState = {
  recordings: {},
  isUploading: false,
};

const audioRecordingsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case AUDIO_RECORDINGS_ACTION_TYPE.GET_AUDIO_RECORDINGS_LIST:
        draft.recordings = payload || initialState.recordings;
        break;

      case AUDIO_RECORDINGS_ACTION_TYPE.GET_AUDIO_RECORDING_URL:
      case AUDIO_RECORDINGS_ACTION_TYPE.CREATE_AUDIO_RECORDING:
      case AUDIO_RECORDINGS_ACTION_TYPE.EDIT_AUDIO_RECORDING:
      case AUDIO_RECORDINGS_ACTION_TYPE.EDIT_AUDIO_RECORDING_CONTENT:
        draft.recordings[payload.audioRecordingId] = {
          ...(draft.recordings[payload.audioRecordingId] || {}),
          ...payload,
        };

        break;

      case AUDIO_RECORDINGS_ACTION_TYPE.DELETE_AUDIO_RECORDING:
        delete draft.recordings[meta.audioRecordingId];
        break;

      case AUDIO_RECORDINGS_ACTION_TYPE.SET_IS_UPLOADING_AUDIO_RECORDING:
        draft.isUploading = payload;
        break;

      default:
        return state;
    }
  });

export default audioRecordingsReducer;
